// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataRealTime_main__Ph+LD"};